import {
  AmountDivisorConversion,
  dealAmount9Valid,
} from "@/Core/utils/currencyDealCenter";
import { IFWalletRsp } from "@/api/apiRsp/IFWalletRsp";
import {
  useGlobalCurrentWallet,
  useGlobalState,
  useGlobalWalletStore,
} from "@/store/commonStore";
import { useWsUpdateBanblce } from "@/store/hallSocket";
import { scheduleRechargeLotteryInfoCacheRefresh } from "@/store/rechargeLottery";
import {
  isRechargeLotteryInfoRefreshTrade,
  isRechargePaymentSuccessTrade,
} from "@/store/rechargeLotteryTrade";
import { useWalletAll } from "@/store/walletStore";
import React, { memo, useCallback, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { formatCurrencyType } from "@/features/common/currencyDisplay/CurrencyDisplay";
import { feedback } from "@/utils/feedback";
import { getRechargeLockedFunReward } from "./rechargeLockedFunReward";
import { isRechargeParamsRefreshTrade, useRechargeParamsRefresh } from "@/store/rechargeParamsRefresh";

const UpdateBanblce = () => {
  const { data } = useWsUpdateBanblce();
  const { mutate } = useWalletAll(false);
  const { isLogin, token } = useGlobalState();
  const refreshRechargeParams = useRechargeParamsRefresh(token, isLogin);
  const { t } = useTranslation();
  const walletRef = useRef<IFWalletRsp>(null);
  const processedBalanceDataRef = useRef<typeof data | null>(null);
  const [globalWallet, setGlobalWallet] = useGlobalWalletStore();
  const [currentWalletGlobal, setCurrentWalletGlobal] = useGlobalCurrentWallet();
  useEffect(() => {
    walletRef.current = globalWallet;
  }, [globalWallet]);

  const updateWalletBalanceByCurrency = useCallback((
    wallet: IFWalletRsp,
    currencyType: string,
    money: number
  ) => {
    const setData = { ...wallet };
    const walletKeys: (keyof IFWalletRsp)[] = [
      "all",
      "swap",
      "flat",
      "crypto",
      "platform",
    ];

    walletKeys.forEach((key) => {
      const list = setData?.[key];
      if (!list?.length) {
        return;
      }
      list.forEach((item) => {
        if (
          item?.currencyType === currencyType ||
          item?.serverCurrencyType === currencyType
        ) {
          item.balance = money;
          item.allBalance = money;
        }
      });
    });

    return setData;
  }, []);

  const updateCurrentWalletGlobal = useCallback((
    setData: IFWalletRsp,
    currencyType: string,
    money: number
  ) => {
    if (
      !currentWalletGlobal ||
      (currentWalletGlobal.currencyType !== currencyType &&
        currentWalletGlobal.serverCurrencyType !== currencyType)
    ) {
      return;
    }
    const updated =
      setData?.all?.find((wallet) => wallet.currencyType === currencyType) ||
      currentWalletGlobal;
    setCurrentWalletGlobal({
      ...updated,
      balance: money,
      allBalance: money,
    });
  }, [currentWalletGlobal, setCurrentWalletGlobal]);

  const handleBalanceChange = useCallback(
    (balanceData: typeof data) => {
      if (!balanceData) {
        return;
      }

      const moneyValue = Number(balanceData?.money);
      if (isNaN(moneyValue)) {
        return;
      }

      // 对GAME_WIN单独处理，延迟2秒
      if (balanceData?.tradeModeCode === "GAME_WIN") {
        if (walletRef.current) {
          setTimeout(() => {
            const setData = updateWalletBalanceByCurrency(
              walletRef.current,
              balanceData?.currencyType,
              moneyValue
            );
            if (setData) {
              setGlobalWallet(setData);
              updateCurrentWalletGlobal(
                setData,
                balanceData?.currencyType,
                moneyValue
              );
            }
          }, 3000);
        }
        return;
      }
      if (
        balanceData?.tradeModeCode === "GAME_BET" ||
          // data?.tradeModeCode === "GAME_WIN"||
        balanceData?.tradeModeCode === "HBY_AWARD"
      ) {
        if (walletRef.current) {
          const setData = updateWalletBalanceByCurrency(
            walletRef.current,
            balanceData?.currencyType,
            moneyValue
          );
          if (setData) {
            // console.log('setData',setData)
            setGlobalWallet(setData);
            updateCurrentWalletGlobal(
              setData,
              balanceData?.currencyType,
              moneyValue
            );
          }
          // mutate(setData, { revalidate: false });
        }
        if (balanceData?.tradeModeCode === "HBY_AWARD") {
          feedback.success({
            content: `${t("SUCC_AQUIRE_MONEY", {
              money:
                AmountDivisorConversion(Number(balanceData?.changedMoney), {
                  currencyType: balanceData?.currencyType,
                }) + `${formatCurrencyType(balanceData?.currencyType)}`,
            })}`,
            className: "hby-message",
          });
          // Notification.success({
          //   title: '',
          //   content: `${t('SUCC_AQUIRE_MONEY', { money: AmountDivisorConversion( Number(data?.changedMoney),{
          //     currencyType: data?.currencyType
          //   }) + `${data?.currencyType}` })}`,
          // });
        }
        return;
      }
      if (isRechargeLotteryInfoRefreshTrade(balanceData?.tradeModeCode)) {
        scheduleRechargeLotteryInfoCacheRefresh(token, isLogin);
      }
      if (walletRef.current) {
        const setData = updateWalletBalanceByCurrency(
          walletRef.current,
          balanceData?.currencyType,
          moneyValue
        );
        if (setData) {
          setGlobalWallet(setData);
          updateCurrentWalletGlobal(
            setData,
            balanceData?.currencyType,
            moneyValue
          );
        }
      }
      if (balanceData?.tradeModeCode === "FIRST_RECHARGE_REBATE") {
        return;
      }
      if (balanceData?.tradeModeCode?.includes("GAME")) {
        return;
      } else if (isRechargePaymentSuccessTrade(balanceData?.tradeModeCode)) {
        const changedMoney = dealAmount9Valid(Number(balanceData?.changedMoney), {
          currencyType: balanceData?.currencyType,
        });
        //充值成功
        feedback.notification.success({
          title: "",
          content: `${t("SUCC_pay", {
            coins: changedMoney + formatCurrencyType(balanceData?.currencyType),
          })}`,
        });
        mutate();
      } else if (balanceData?.tradeModeCode?.includes("VIP_TURNTABLE_AWARD")) {
        //转盘获奖提示
        // setTimeout(()=>{
        //     Notification.success({
        //         title: '',
        //         content: `${t('SUCC_GET_MAIL_COINS', { coins: money + `${data?.currencyType}` })}`
        //     })
        // },6000)
        // console.log(`${data?.currencyType}`)
      } else if (balanceData?.tradeModeCode?.includes("CONSUME")) {
        // //钱包兑换 ：消耗
        // Notification.success({
        //   title: '',
        //   content: `${t('SUCC_CONSUME_MONEY', { money: money + `${data?.currencyType}` })}`,
        // });
        // revalidate();
      } else if (balanceData?.tradeModeCode?.includes("ACQUIRE")) {
        const changedMoney = dealAmount9Valid(Number(balanceData?.changedMoney), {
          currencyType: balanceData?.currencyType,
        });
        //钱包兑换 ：获得
        feedback.notification.success({
          title: "",
          content: `${t("SUCC_AQUIRE_MONEY", {
            money: changedMoney + formatCurrencyType(balanceData?.currencyType),
          })}`,
        });
        mutate();
      } else if (balanceData?.tradeModeCode?.includes("_WITHDRAW")) {
        const changedMoney = dealAmount9Valid(Number(balanceData?.changedMoney), {
          currencyType: balanceData?.currencyType,
        });
        //钱包提现
        feedback.notification.success({
          title: "",
          content: `${t("SUCC_WITHDRAW_MONEY", {
            money: changedMoney + formatCurrencyType(balanceData?.currencyType),
          })}`,
        });
        mutate();
      } else if (balanceData?.tradeModeCode?.includes("TRANSIN")) {
        // 进游戏更新钱包
        mutate();
      } else if (balanceData?.tradeModeCode?.includes("TRANSOUT")) {
        // 游戏退出刷新钱包
        mutate();
      } else {
        const changedMoney = dealAmount9Valid(Number(balanceData?.changedMoney), {
          currencyType: balanceData?.currencyType,
        });
        feedback.notification.success({
          title: "",
          content: `${t("SUCC_GET_MAIL_COINS", {
            coins: changedMoney + formatCurrencyType(balanceData?.currencyType),
          })}`,
        });
        mutate();
      }
    },
    [
      isLogin,
      mutate,
      setGlobalWallet,
      t,
      token,
      updateCurrentWalletGlobal,
      updateWalletBalanceByCurrency,
    ]
  );

  useEffect(() => {
    if (!data || processedBalanceDataRef.current === data) {
      return;
    }

    processedBalanceDataRef.current = data;
    if (isRechargeParamsRefreshTrade(data.tradeModeCode)) {
      refreshRechargeParams();
    }
    console.log("[ws][balance-change] received", {
      tradeModeCode: data.tradeModeCode,
      currencyType: data.currencyType,
      money: data.money,
      changedMoney: data.changedMoney,
      payload: data,
    });
    const lockedReward = getRechargeLockedFunReward(data);
    if (lockedReward !== undefined) {
      if (lockedReward > 0) {
        feedback.notification.success({
          title: "",
          content: t("SUCC_GET_LOCKED_FUN", {
            coins: `${dealAmount9Valid(lockedReward, { currencyType: data.currencyType })} ${formatCurrencyType(data.currencyType)}`,
          }),
        });
      }
      // Refresh both balances from the wallet API; money here is only the reward.
      mutate();
      return;
    }
    handleBalanceChange(data);
  }, [data, handleBalanceChange, mutate, t, refreshRechargeParams]);
  return <></>;
};

export default memo(UpdateBanblce);
